<div class="rs-maxh rs-padding-bottom2" data-cy="nortonSubscriptionsSection">
  <div class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh">
    <h3 class="rs-tit6">{{ 'norton.subscription.title' | translate }}</h3>
    <div class="rs-flex-row">
      <div class="rs-flex-columns small-12 medium-6">
        <div class="rs-maxh rs-padding-bottom2">
          <div class="panel rs-no-margin-bottom rs-maxh">
            <div class="rs-flex-row">
              <div class="rs-flex-column">
                <p>
                  <strong>{{ norton1Name }}</strong>
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p>
                  <strong
                    >{{ norton1Count }}&nbsp;{{
                      'norton.subscription.subscriptions' | translate
                    }}</strong
                  >
                </p>
              </div>
            </div>
            <p [innerHTML]="getDescriptionLabel(norton1Count * norton1LicenseCount)"></p>
          </div>
        </div>
      </div>
      <div class="rs-flex-columns small-12 medium-6">
        <div class="rs-maxh rs-padding-bottom2">
          <div class="panel rs-no-margin-bottom rs-maxh">
            <div class="rs-flex-row">
              <div class="rs-flex-column">
                <p>
                  <strong>{{ norton5Name }}</strong>
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p>
                  <strong
                    >{{ norton5Count }}&nbsp;{{
                      'norton.subscription.subscriptions' | translate
                    }}</strong
                  >
                </p>
              </div>
            </div>
            <p [innerHTML]="getDescriptionLabel(norton5Count * norton5LicenseCount)"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
      <div class="rs-flex-columns rs-flex-grow rs-order-m1">
        <p>
          {{ 'norton.subscription.addExtraLicense' | translate }}&nbsp;
          <span class="rs-price-s"
            ><span class="rs-nowrap"
              ><span class="rs-euro">€</span><span class="rs-unit">{{ price }}</span></span
            ></span
          >{{ frequency | chargeFrequency }}
        </p>
      </div>
      <div class="rs-flex-columns rs-order-m3">
        <div class="small-only-text-center">
          <a
            href="{{ 'norton.subscription.button.extraLicense.link' | translate }}"
            target="_blank"
            data-tms-event="button-click"
            attr.data-tms-button-zone="{{ 'norton.subscription.title' | translate }}"
            attr.data-tms-button-name="{{
              'norton.subscription.button.extraLicense.label' | translate
            }}"
            class="rs-btn rs-btn-order"
            >{{ 'norton.subscription.button.extraLicense.label' | translate }}</a
          >
        </div>
      </div>
      <div
        class="rs-flex-columns rs-order-m2"
        *ngIf="(!isAlwaysProtectedValue || !nortonProdValue) &&'norton.subscription.button.cancel.link' | translate"
      >
        <p class="small-only-text-center">
          <a
            href="{{ 'norton.subscription.button.cancel.link' | translate }}"
            target="_blank"
            data-tms-event="link-click"
            attr.data-tms-link-zone="{{ 'norton.subscription.title' | translate }}"
            attr.data-tms-link-name="{{ 'norton.subscription.button.cancel.label' | translate }}"
            attr.data-tms-link-url="{{ 'norton.subscription.button.cancel.link' | translate }}"
            >{{ 'norton.subscription.button.cancel.label' | translate }}</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
